import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.975 12c-.256-3.355-3.054-6-6.475-6s-6.219 2.645-6.475 6H0v1h19v-1h-3.025zm-11.95 0C4.279 9.201 6.636 7 9.5 7s5.221 2.201 5.475 5H4.026z',
  ],
  height: 20,
  width: 20,
});
